/* =========================================================================
 * Featured Collection (tiered) — client behavior
 * -------------------------------------------------------------------------
 * - Tier radio-group with arrow-key navigation + Enter/Space selection
 * - Live per-can price, total, was-price, save-line updates (no reload)
 * - Shopify AJAX add-to-cart (POST /cart/add.js)
 * - Cart drawer refresh hook (Dawn <cart-drawer>) + cart:refresh event
 * - Toast notification
 * =========================================================================
 */
(function () {
  'use strict';

  if (window.__FCT_INIT__) return;
  window.__FCT_INIT__ = true;

  // ------------------------------------------------------ formatting helpers
  /**
   * Format a decimal amount (e.g. 3.86) using the card's data-money-format.
   * Falls back to `N.XX` if format string can't be parsed.
   */
  function formatMoney(amount, fmt) {
    var val = (Math.round(amount * 100) / 100);
    var intPart, fracPart;
    if (!fmt) {
      return val.toFixed(2);
    }
    // Shopify tokens: {{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}, ...
    // Keep it simple: detect comma-decimal format vs dot-decimal.
    function withDelims(num, thousands, decimal) {
      var parts = num.toFixed(2).split('.');
      intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      fracPart = parts[1];
      return intPart + decimal + fracPart;
    }
    try {
      if (fmt.indexOf('amount_with_comma_separator') !== -1) {
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDelims(val, '.', ','));
      }
      if (fmt.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
        return fmt.replace(/\{\{[^}]+\}\}/g, withDelims(Math.round(val), '.', ',').replace(/,00$/, ''));
      }
      if (fmt.indexOf('amount_no_decimals') !== -1) {
        return fmt.replace(/\{\{[^}]+\}\}/g, String(Math.round(val)));
      }
      // default: amount
      return fmt.replace(/\{\{[^}]+\}\}/g, withDelims(val, ',', '.'));
    } catch (e) {
      return val.toFixed(2);
    }
  }

  // ----------------------------------------------------------- card helpers
  function parseTierConfig(card) {
    var scriptEl = card.querySelector('.fct-tier-config');
    try { return JSON.parse(scriptEl.textContent); } catch (e) { return []; }
  }

  function computePrices(basePrice, tier) {
    var perCan = basePrice * (1 - (tier.pct / 100));
    perCan = Math.round(perCan * 100) / 100;
    var total  = Math.round(perCan * tier.qty * 100) / 100;
    return { perCan: perCan, total: total };
  }

  function selectTier(card, tierId) {
    var buttons = card.querySelectorAll('.fct-tier');
    var selected = null;
    buttons.forEach(function (btn) {
      var isMatch = btn.getAttribute('data-tier-id') === tierId;
      btn.classList.toggle('is-selected', isMatch);
      btn.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      btn.setAttribute('tabindex', isMatch ? '0' : '-1');
      if (isMatch) selected = btn;
    });
    if (!selected) return;

    var tiers = parseTierConfig(card);
    var tier = tiers.find(function (t) { return t.id === tierId; });
    if (!tier) return;

    var basePrice = parseFloat(card.getAttribute('data-variant-price')) || 0;
    var compareAt = parseFloat(card.getAttribute('data-variant-compare')) || 0;
    var fmt = card.getAttribute('data-money-format') || '';

    var prices = computePrices(basePrice, tier);

    var percanEl = card.querySelector('[data-fct-percan]');
    var totalEl  = card.querySelector('[data-fct-total]');
    var saveEl   = card.querySelector('[data-fct-save]');
    var wasEl    = card.querySelector('[data-fct-was]');

    if (percanEl) percanEl.textContent = formatMoney(prices.perCan, fmt) + ' / can';
    if (totalEl)  totalEl.textContent  = formatMoney(prices.total,  fmt);

    // was-price row: tier.pct * qty multiplied OR compare_at if available
    if (compareAt > 0) {
      var wasTotal = Math.round(compareAt * tier.qty * 100) / 100;
      if (wasEl)  wasEl.textContent  = formatMoney(wasTotal, fmt);
      if (saveEl) {
        var savedPct = Math.round((compareAt - prices.perCan) / compareAt * 100);
        if (isFinite(savedPct) && savedPct > 0) {
          saveEl.textContent = 'You save ' + savedPct + '%';
        } else if (tier.pct > 0) {
          saveEl.textContent = 'You save ' + tier.pct + '%';
        } else {
          saveEl.textContent = '';
        }
      }
    } else {
      if (wasEl)  wasEl.textContent  = '';
      if (saveEl) saveEl.textContent = tier.pct > 0 ? 'You save ' + tier.pct + '%' : '';
    }
  }

  // ----------------------------------------------------- keyboard navigation
  function handleKey(e, card) {
    var key = e.key;
    if (['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End',' ','Enter'].indexOf(key) === -1) return;
    var buttons = Array.prototype.slice.call(card.querySelectorAll('.fct-tier'));
    var activeIdx = buttons.indexOf(document.activeElement);
    if (activeIdx === -1) return;

    if (key === 'Enter' || key === ' ') {
      e.preventDefault();
      var tid = buttons[activeIdx].getAttribute('data-tier-id');
      selectTier(card, tid);
      return;
    }
    e.preventDefault();
    var newIdx = activeIdx;
    if (key === 'ArrowDown' || key === 'ArrowRight') newIdx = (activeIdx + 1) % buttons.length;
    else if (key === 'ArrowUp' || key === 'ArrowLeft') newIdx = (activeIdx - 1 + buttons.length) % buttons.length;
    else if (key === 'Home') newIdx = 0;
    else if (key === 'End')  newIdx = buttons.length - 1;
    buttons[newIdx].focus();
    // Auto-select on navigation to mimic radio behaviour
    selectTier(card, buttons[newIdx].getAttribute('data-tier-id'));
  }

  // --------------------------------------------------------------- toast
  var toastEl;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'fct-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });
    clearTimeout(toastEl._hideT);
    toastEl._hideT = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 1800);
  }

  // -------------------------------------------------------- add to cart
  function addToCart(card, btn) {
    var variantId = card.getAttribute('data-variant-id');
    var title     = card.getAttribute('data-product-title') || 'Product';
    var selectedTier = card.querySelector('.fct-tier.is-selected');
    if (!selectedTier) return;
    var tiers = parseTierConfig(card);
    var tierId = selectedTier.getAttribute('data-tier-id');
    var tier = tiers.find(function (t) { return t.id === tierId; });
    if (!tier) return;

    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: tier.qty })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    })
    .then(function () {
      showToast('Added ' + tier.qty + ' × ' + title + ' to cart');
      // Update status region for SR
      var statusEl = card.closest('.fct-section').querySelector('.fct-sr');
      if (statusEl) statusEl.textContent = 'Added ' + tier.qty + ' ' + title + ' to cart.';

      // Fire cart:refresh event (theme-agnostic)
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      // Dawn-style cart drawer refresh — fetch /cart.js and update sections
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          try { drawer.renderContents(cart); } catch (e) { /* ignore */ }
        });
      }
      // Try a cart-notification element too
      var note = document.querySelector('cart-notification');
      if (note && typeof note.renderContents === 'function') {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          try { note.renderContents(cart); } catch (e) {}
        });
      }

      btn.textContent = 'Added ✓';
      setTimeout(function () {
        btn.textContent = origText;
        btn.disabled = false;
      }, 900);
    })
    .catch(function (err) {
      console.error('[FCT] add-to-cart failed', err);
      showToast('Could not add to cart');
      btn.textContent = origText;
      btn.disabled = false;
    });
  }

  // --------------------------------------------------------------- init
  function initCard(card) {
    if (card.__fctInit) return;
    card.__fctInit = true;

    var defaultTier = card.getAttribute('data-default-tier') || '30';
    selectTier(card, defaultTier);

    card.querySelectorAll('.fct-tier').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectTier(card, btn.getAttribute('data-tier-id'));
      });
    });

    var group = card.querySelector('.fct-tiers');
    if (group) {
      group.addEventListener('keydown', function (e) { handleKey(e, card); });
    }

    var atc = card.querySelector('[data-fct-atc]');
    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.disabled) return;
        addToCart(card, atc);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-fct-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init on Shopify section rerenders (customizer)
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
